import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../Button.js';
import Modal from '../../../Modal.js';
import Staevning from '../../CreateTribunalCase/types/Staevning.js';
const ResendStaevning = (props) => {
    const lang = useSelector((s) => s.lang);
    const [modalOpen, setModalOpen] = useState(false);
    const lastJob = props.pastJobs[0];
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: () => setModalOpen(true) }, lang.tribunal.editStaevning),
        modalOpen && (React.createElement(Modal, { header: lang.tribunal.resendStaevning, onToggle: () => setModalOpen(false) },
            React.createElement(Staevning, { caseId: props.tribunalCase.caseId, caseSequentialId: props.caseSeqId, tenantId: props.tenantId, resending: true, tribunalCaseId: props.tribunalCase.id, prefill: {
                    ...lastJob.data,
                    addCourtDisbursementToClientBilling: false,
                    addCourtFeeToCase: false,
                    addCourtFeeToClientBilling: false,
                    sendInfoToEconomyResponsible: false,
                }, onCreated: () => {
                    setModalOpen(false);
                } })))));
};
export default ResendStaevning;
//# sourceMappingURL=ResendStaevning.js.map